module.exports = __webpack_public_path__ + "static/img/title.b244ea1.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/title.png
// module id = LYEO
// module chunks = 7